import React from 'react';
import PendingActivationTable from './PendingActivationTable';
import { Col, Row } from 'react-bootstrap';

const propTypes = {};

const defaultProps = {};

function PendingActivation() {
    return (
        <Row data-testid="user-manager-pending-activation-tab-content">
            <Col md={12}>
                <PendingActivationTable />
            </Col>
        </Row>
    );
}

PendingActivation.propTypes = propTypes;
PendingActivation.defaultProps = defaultProps;

export default PendingActivation;
